import _ from "lodash";

export const SuppleTermsRefDroOpts = () => {
    const LATE_ARRIVAL_GRACE = {
        N_A: "N/A",
        MULTIPLY_BY_QC: "Multiply by QC"
    };

    const HANDLE_SHORTSEA_AS = ["SD", "SB"];

    const BILLING_INBOUND_NON_CY_AS = ["2", "3"];

    const BILLING_OUTBOUND_NON_CY_AS = ["1", "3"];

    const getLateArrGraceDroOptsModel = () => {
        let ret = LATE_ARRIVAL_GRACE;

        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    const getHandleShortSeaAsDroOptsModel = () => {
        let ret = HANDLE_SHORTSEA_AS;

        return [
            ...(ret?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    const getBillingTypeInboundNonCyDroOptsModel = () => {
        let ret = BILLING_INBOUND_NON_CY_AS;

        return [
            ...(ret?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    const getBillingTypeOutboundNonCyDroOptsModel = () => {
        let ret = BILLING_OUTBOUND_NON_CY_AS;

        return [
            ...(ret?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    return {
        getLateArrGraceDroOptsModel,
        getHandleShortSeaAsDroOptsModel,
        getBillingTypeInboundNonCyDroOptsModel,
        getBillingTypeOutboundNonCyDroOptsModel,
    }
}